export class UserData {
    id: number;
    userId: string;
    clientId: number;
    employeeId: string;
    password: string;
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
    displayName: string;
    roles: any[];
    roleNames: [];
    displayRole: string;
    dateOfBirth: string;
    phoneNumber: string;
    isActive: Boolean;
    effectiveDate: string;
    terminationDate: string;
    authToken: string;
    npi: string;

    updatedTimestamp: string;
    createdTimestamp: string;
    createdBy: string;
    updatedBy: string;

    lastLogin: Date;
    lastLoginIP: string;
    portals: any[];

    licensedState: string;
    licensedExpiryDate: Date;
    licensedStartDate: Date;
    serviceAddress1: string;
    serviceAddress2: string;
    serviceCity: string;
    serviceState: string;
    serviceZip: string;

    otpPreference: number;
    timeZone: number;

    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    title: string;
}
